var _path, _path2, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFwdButtonImg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 76,
    viewBox: "0 0 68 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 2.13397L27.5 1.8453L27 2.13397L3.1843 15.884L2.6843 16.1726V16.75V44.25V44.8274L3.1843 45.116L27 58.866L27.5 59.1547L28 58.866L51.8157 45.116L52.3157 44.8274V44.25V16.75V16.1726L51.8157 15.884L28 2.13397Z",
    fill: "white",
    fillOpacity: 0.1,
    stroke: "#E4DEFF",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19 39L28.7143 31.5L19 24V39ZM29.2857 24V39L39 31.5L29.2857 24Z",
    fill: "#E4DEFF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9810_3553)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19 39L28.7143 31.5L19 24V39ZM29.2857 24V39L39 31.5L29.2857 24Z",
    fill: "#E4DEFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9810_3553"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(19 21)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFwdButtonImg);
export default __webpack_public_path__ + "static/media/FwdButtonImg.5b8b3a6be38c427c276bf3b5f2fccc99.svg";
export { ForwardRef as ReactComponent };